import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

type Props = {
  label: string;
  price: number;
  info: string;
  allowedWeight: string;
  size: string;
};

const GrassSizeCart = ({
  label,
  price,
  info,
  allowedWeight,
  size,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.grassSizeCart}>
      <h3>{label} {t("pets")}</h3>
      <div className={styles.price}>€{price}</div>
      <p>
        {info}
        <br />
        ({allowedWeight})
      </p>
      <img src={require(`../../../assets/images/sizes/${size}/size.avif`)} alt="" />
    </div>
  );
};

export default GrassSizeCart;
